
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { AiOutlineDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { useToast } from "../../components/ui/ToastContext";
import { FaRegCheckCircle, FaRegTimesCircle, FaExclamationTriangle, FaEye } from "react-icons/fa";
import dayjs from "dayjs";
import { jwtDecode } from 'jwt-decode';
import utc from 'dayjs/plugin/utc'
import { API_URL } from "../../config";
import { GrValidate } from "react-icons/gr";
import { LuCircleCheck } from "react-icons/lu";
import { LuCircleX } from "react-icons/lu";
import { Checkbox } from "@mui/material";
import { logAuditUI } from "../../utils/auditLogger";

dayjs.extend(utc);
dayjs.tz.guess();

function DashboardCard25() {
  const { showToast } = useToast();
  const navigate = useNavigate();
  const [Data, setData] = useState([]);
  const [Data2, setData2] = useState([]);
  const [showGrid, setShowGrid] = useState(true);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [selectedInstitutionId, setSelectedInstitutionId] = useState(null);
  const [selecteduser, setSelecteduser] = useState(null);
  const [selecteduser2, setSelecteduser2] = useState(null);
  const [user, setUser] = useState(null);
  const [searchQuery1, setSearchQuery1] = useState('');
  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);
  const [selecteduser3, setSelecteduser3] = useState(null);
  const [selecteduser4, setSelecteduser4] = useState(null);
  const token = localStorage.getItem('jwtToken');
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0
  });

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }

    logAuditUI({
      actionType: 'VIEW_LIST',
      module: 'Raportare',
      description: 'A vizualizat lista de vizite raportate',
    });
  }, [token]);

  const fetchData = async () => {
    try {
      const response = await axios.post(`${API_URL}/api/totalreporting`, {
        user_id: user.userId,
        page: currentPage || 1,
        pageSize: itemsPerPage,
        search: searchQuery1,
        activity_type_id: 1
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const planningData = response.data.data;
      const van = planningData.flatMap((i) => i.visits);
      const paginationInfo = response.data.pagination;
      const vvv = van.flatMap((i) => i.reports).filter((i) => i?.activity_type_id !== 2);
      const val = van.map((i) => ({
        user_names: i.user_names,
        visit_date: i.visit_date,
        user_id: i.user_id,
        reports: i.reports.length
      }));
      console
      setData(val);
      console.log(vvv)
      setData2(vvv);
      setPagination(paginationInfo);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setShowGrid(false);
    }
  };

  useEffect(() => {
    if (!user) return;
    if (currentPage > 0) {
      fetchData();
    }
  }, [user, currentPage, searchQuery1]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery1]);

  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     setShowGrid(false);
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem('selectedReportDayId');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem("selectedReportDayId");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setSelectedInstitutionId(parsed);
      } catch (error) {
        console.error("Invalid JSON in localStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    const saved = localStorage.getItem("SearchQ");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        setSearchQuery1(parsed);
      } catch (error) {
        console.error("Invalid JSON in localStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (selecteddeleteuser) {
      deleteRow();
    }
  }, [selecteddeleteuser]);

  useEffect(() => {
    if (selecteduser) {
      handleNewRows1(selecteduser);
    }
  }, [selecteduser]);

  useEffect(() => {
    if (selecteduser2) {
      handleNewRows3(selecteduser2);
    }
  }, [selecteduser2]);

  useEffect(() => {
    if (selecteduser3) {
      handleNewRows4(selecteduser3);
    }
  }, [selecteduser3]);

  useEffect(() => {
    if (selecteduser4) {
      const val = Data2.filter((i) => i.user_id === selecteduser4.user_id && i.visit_date === selecteduser4.visit_date)
      handleNewRows5(val);
    }
  }, [selecteduser4]);

  const handleNewRows = (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Raportare',
      description: 'A deschis formularul de creare raportare',
    });
    navigate("/reporting/createreporting");
  };

  const handleNewRows1 = (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Raportare',
      entityId: item?.report_id,
      description: `A deschis formularul de editare raportare (ID: ${item?.report_id || ''})`,
    });
    navigate("/reporting/editreporting", { state: { item } });
  };

  const handleNewRows3 = (item) => {
    logAuditUI({
      actionType: 'OPEN_FORM',
      module: 'Raportare',
      entityId: item?.report_id,
      description: `A deschis formularul de vizualizare raportare (ID: ${item?.report_id || ''})`,
    });
    navigate("/reporting/viwereporting", { state: { item } });
  };

  const anulat = async () => {
    showToast({
      message: "Anulat",
      type: "success",
      icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      duration: 20
    });
  };

  const handleNewRows4 = (item) => {
    showToast({
      message: (
        <div>
          <p>Sigur doriți să validati această înregistrare?</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete1();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat(); setSelecteduser3("") }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  };

  const handleNewRows5 = (item) => {
    showToast({
      message: (
        <div>
          <p>Sigur doriți să validati această înregistrare?</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDeleteAll(item);
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => { anulat(); setSelecteduser4("") }}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  };

  const confirmDeleteAll = async (items) => {
    try {
      for (const item of items) {
        await axios.put(`${API_URL}/api/validatereport`, {
          report_id: item.report_detail_id,
          is_validated: !item.is_validated,
          submited_user_id: user?.userId,
          planning_id: item.planning_id
        });
      }

      fetchData();
      showToast({
        message: "Toate datele au fost validate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la validarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const confirmDelete1 = async () => {
    if (selecteduser3.report_detail_id != null && user?.userId != null) {
      try {
        await axios.put(
          `${API_URL}/api/validatereport`,
          {
            report_id: selecteduser3.report_detail_id,
            is_validated: !selecteduser3.is_validated,
            submited_user_id: user?.userId,
            planning_id: selecteduser3.planning_id
          }
        );
        fetchData();
        showToast({
          message: "Datele au fost validate cu succes!",
          type: "success",
          icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
        });
      } catch (error) {
        console.error(error);
        showToast({
          message: "Eroare la validarea datelor!",
          type: "error",
          icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
        });
      }
    } else {
      showToast({
        message: "ID-ul zilei de planificare este invalid.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const deleteRow = async () => {
    if (!selecteddeleteuser) {
      showToast({
        message: "Nu a fost selectată nicio înregistrare pentru ștergere.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
      return;
    }

    showToast({
      message: (
        <div>
          <p>Sigur doriți să ștergeți această înregistrare?</p>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-red-700 text-white rounded-md"
              onClick={async () => {
                await confirmDelete();
              }}
            >
              Da
            </button>
            <button
              className="px-3 py-1 bg-gray-400 text-white rounded-md"
              onClick={() => showToast({ show: false })}
            >
              Nu
            </button>
          </div>
        </div>
      ),
      type: "warning",
      icon: <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-500" />,
    });
  };

  const confirmDelete = async () => {
    setData2((prevData) => {
      const filteredData = prevData.filter(
        (item) => item.report_detail_id !== selecteddeleteuser.report_detail_id
      );
      return filteredData;
    });

    if (selecteddeleteuser.report_detail_id != null) {
      try {
        await axios.put(`${API_URL}/api/deletereportdetail`, {
          report_detail_id: selecteddeleteuser.report_detail_id,
          submited_user_id: user?.userId,
          planning_id: selecteddeleteuser.planning_id
        });

        showToast({
          message: "Datele au fost șterse cu succes!",
          type: "success",
          icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
        });

      } catch (error) {
        console.error(error);
        showToast({
          message: "Eroare la ștergerea datelor!",
          type: "error",
          icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
        });
      }
    } else {
      showToast({
        message: "ID-ul zilei de raportare este invalid.",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handlePageChange = (newPage) => {
    const validPage = Math.max(1, Math.min(newPage, pagination.totalPages));
    setCurrentPage(validPage);
  };

  return (
    <div>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <div className=" xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl ">
          <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 ">
            <div className="lg:flex lg:items-center lg:justify-between d-flex flex-column flex-md-row justify-content-between align-items-start">
              <h2 className=" font-bold text-gray-800 dark:text-gray-100 mb-4 sm:mb-0 md:mb-0">Raportare</h2>
              <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto md:flex md:items-center md:gap-4 md:w-auto">
                <div className="relative w-full sm:w-64 md:w-80">
                  <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:border-blue-500 focus:outline-none dark:bg-gray-800 dark:text-gray-200 "
                    placeholder="Căutare"
                    value={searchQuery1}
                    onChange={(e) => {
                      setSearchQuery1(e.target.value);
                      localStorage.setItem("SearchQ", JSON.stringify(e.target.value));
                    }} />
                </div>

                <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white mt-4 sm:mt-0"
                  onClick={() => handleNewRows()}
                >
                  <span className="//max-xs:sr-only">Adauga o raportare neplanificata</span>
                </button>
              </div>
            </div>
          </header>

          <div className="p-3 " >
            <div className="w-full overflow-x-auto">
              <table className="w-full table-auto ">
                <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                  <tr>
                    <th className="p-2 text-left font-semibold">Data raportarii</th>
                    <th className="p-2 text-left font-semibold">Utilizator</th>
                    <th className="p-2 text-center font-semibold">Numarul de vizite</th>
                    <th className="p-2 text-center font-semibold">Actiune</th>
                  </tr>
                </thead>
                <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                  {[...Data].sort((a, b) => new Date(b.visit_date) - new Date(a.visit_date))
                    .map((customer, index) => {
                      const isSelected = selectedInstitutionId?.visit_date === customer.visit_date && selectedInstitutionId?.user_id === customer.user_id;
                      return (
                        <React.Fragment key={`customer-${customer.visit_date}-${index}`}>
                          <tr
                            role="button"
                            className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"} hover:bg-gray-200 dark:hover:bg-gray-600`}

                          >
                            <td className="p-2 whitespace-nowrap"
                              onClick={(e) => {
                                e.stopPropagation();
                                const isSame = selectedInstitutionId?.visit_date === customer.visit_date && selectedInstitutionId?.user_id === customer.user_id;
                                const planningDayId = isSame ? null : { visit_date: customer.visit_date, user_id: customer.user_id };
                                setSelectedInstitutionId(planningDayId);
                                if (isSame) {
                                  setSelectedInstitutionId(null);
                                  localStorage.removeItem("selectedReportDayId");
                                } else {
                                  setSelectedInstitutionId(planningDayId);
                                  localStorage.setItem("selectedReportDayId", JSON.stringify(planningDayId));
                                }
                              }}>
                              <div className="text-left">{customer.visit_date ? dayjs.utc(customer.visit_date).format("DD-MM-YYYY") : "-"}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap"
                              onClick={(e) => {
                                e.stopPropagation();
                                const isSame = selectedInstitutionId?.visit_date === customer.visit_date && selectedInstitutionId?.user_id === customer.user_id;
                                const planningDayId = isSame ? null : { visit_date: customer.visit_date, user_id: customer.user_id };
                                setSelectedInstitutionId(planningDayId);
                                if (isSame) {
                                  setSelectedInstitutionId(null);
                                  localStorage.removeItem("selectedReportDayId");
                                } else {
                                  setSelectedInstitutionId(planningDayId);
                                  localStorage.setItem("selectedReportDayId", JSON.stringify(planningDayId));
                                }
                              }}>
                              <div className="text-left">{customer.user_names || "-"}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap"
                              onClick={(e) => {
                                e.stopPropagation();
                                const isSame = selectedInstitutionId?.visit_date === customer.visit_date && selectedInstitutionId?.user_id === customer.user_id;
                                const planningDayId = isSame ? null : { visit_date: customer.visit_date, user_id: customer.user_id };
                                setSelectedInstitutionId(planningDayId);
                                if (isSame) {
                                  setSelectedInstitutionId(null);
                                  localStorage.removeItem("selectedReportDayId");
                                } else {
                                  setSelectedInstitutionId(planningDayId);
                                  localStorage.setItem("selectedReportDayId", JSON.stringify(planningDayId));
                                }
                              }}>
                              <div className="text-center">{customer.reports}</div>
                            </td>
                            <td>
                              <div className="font-semibold text-center"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "20px"
                                }}
                              >
                                {user && user.role !== 'User' && (
                                  <Tooltip title="Validare" arrow placement="top">
                                    <IconButton
                                      onClick={() => setSelecteduser4(customer)}
                                      color="primary"
                                      sx={{
                                        fontSize: "16px",
                                        borderRadius: "50%",
                                        "&:hover": {
                                          backgroundColor: "#a4adad",
                                        },
                                      }}
                                    >
                                      <GrValidate className=" dark:text-gray-100" />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </div>
                            </td>
                          </tr>
                          {isSelected && (
                            <tr className="bg-gray-50 dark:bg-gray-800">
                              <td colSpan="4" className="p-2">
                                <div className="w-full overflow-x-auto max-xs:max-h-[50vh]">
                                  <table className=" max-xs:sr-only w-full table-auto  border border-gray-300 dark:border-gray-600 ">
                                    <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                      <tr>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Interval ora</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Doctor</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Specialitatea</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Tip</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Institutia</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Adresa</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Oras</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Tip</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Vizita Dubla</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-left">Validat</div>
                                        </th>
                                        <th className="p-2">
                                          <div className="font-semibold text-center">Actiune</div>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Data2.filter((i) => i.visit_date === selectedInstitutionId.visit_date && i.user_id === selectedInstitutionId.user_id)
                                        .sort((a, b) => new Date(a.start_time) - new Date(b.start_time)).map((item, idx) => {
                                          return (
                                            <React.Fragment key={idx}>
                                              <tr key={`address-${idx}`} className="border border-gray-300 dark:border-gray-600" role="button">
                                                <td className="p-2 " onClick={() => setSelecteduser2(item)}>
                                                  {item.report_start_time && item.report_end_time && dayjs(item.report_start_time).isValid() && dayjs(item.report_end_time).isValid()
                                                    ? dayjs.utc(item.report_start_time).format('HH:mm') + ' - ' + dayjs.utc(item.report_end_time).format('HH:mm')
                                                    : '-'}
                                                </td>
                                                <td className="p-2 " onClick={() => setSelecteduser2(item)}>
                                                  {item.obiect_type_id === 1 ? (
                                                    <div className="flex items-center gap-1.5">
                                                      <span>{item.physician?.name || item.physician || "-"}</span>
                                                      {(item.physician?.data_acord || item.data_acord) ? (
                                                        <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                          <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                          </svg>
                                                        </span>
                                                      ) : null}
                                                    </div>
                                                  ) : "-"}
                                                </td>
                                                <td className="p-2 " onClick={() => setSelecteduser2(item)}>{item.obiect_type_id === 1 ? item.physician.speciality || "-" : "-"}</td>
                                                <td className="p-2 " onClick={() => setSelecteduser2(item)}>{item.location?.inst_type}</td>
                                                <td className="p-2 " onClick={() => setSelecteduser2(item)}>{item.location?.institution}</td>
                                                <td className="p-2 " onClick={() => setSelecteduser2(item)}>{item.location?.address}</td>
                                                <td className="p-2 " onClick={() => setSelecteduser2(item)}>{item.location?.city}</td>
                                                <td className="p-2 ">{item.planning_type_id === 1 ? "Planificat" : "Neplanificat"}</td>
                                                <td className="p-2 //whitespace-nowrap">
                                                  <div className="text-left">
                                                    <Checkbox
                                                      disabled={true}
                                                      checked={item.is_double_visit || false}
                                                      sx={{
                                                        color: item.is_double_visit ? "#10b981" : "#9ca3af",
                                                        '&.Mui-checked': {
                                                          color: "#10b981",
                                                        },
                                                        '&:hover': {
                                                          backgroundColor: "rgba(16, 185, 129, 0.1)",
                                                        },
                                                        padding: "4px",
                                                      }}
                                                    />
                                                  </div>
                                                </td>
                                                <td className="p-2  h-full">
                                                  <div className={`flex items-center justify-center font-semibold ${item.is_validated ? 'text-green-500' : 'text-red-500'}`}
                                                    style={{
                                                      fontWeight: "bold",
                                                      fontSize: "20px",
                                                      height: "100%",
                                                    }}>
                                                    {item.is_validated ? <LuCircleCheck size={20} /> : <LuCircleX size={20} />}
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="font-semibold text-center"
                                                    style={{
                                                      fontWeight: "bold",
                                                      fontSize: "20px"
                                                    }}
                                                  >
                                                    <Tooltip title="Editeaza" arrow placement="top">
                                                      <IconButton
                                                        onClick={() => setSelecteduser(item)}
                                                        data-tooltip-target="tooltip-default"
                                                        color="primary"
                                                        disabled={item.is_validated}
                                                        sx={{
                                                          fontSize: "16px",
                                                          borderRadius: "50%",
                                                          "&:hover": {
                                                            backgroundColor: "#a4adad",
                                                          },
                                                          "&.Mui-disabled": {
                                                            visibility: "hidden",
                                                            color: "rgba(0, 0, 0, 0.09)",
                                                            backgroundColor: "rgba(255, 255, 255, 0)",
                                                          },
                                                        }}
                                                      >
                                                        <AiFillEdit className=" dark:text-gray-100" />
                                                      </IconButton>
                                                    </Tooltip>

                                                    <Tooltip title="Sterge" arrow placement="top">
                                                      <IconButton
                                                        onClick={() => setSelecteddeleteuser(item)}
                                                        color="primary"
                                                        sx={{
                                                          fontSize: "16px",
                                                          borderRadius: "50%",
                                                          "&:hover": {
                                                            backgroundColor: "#a4adad",
                                                          },
                                                        }}
                                                      >
                                                        <AiOutlineDelete className=" dark:text-gray-100" />
                                                      </IconButton>
                                                    </Tooltip>

                                                    <Tooltip title="Vizualizeaza" arrow placement="top">
                                                      <IconButton
                                                        onClick={() => setSelecteduser2(item)}
                                                        color="primary"
                                                        sx={{
                                                          fontSize: "16px",
                                                          borderRadius: "50%",
                                                          "&:hover": {
                                                            backgroundColor: "#a4adad",
                                                          },
                                                        }}
                                                      >
                                                        <FaEye className=" dark:text-gray-100" />
                                                      </IconButton>
                                                    </Tooltip>

                                                    {user && user.role !== 'User' && (
                                                      <Tooltip title="Validare" arrow placement="top">
                                                        <IconButton
                                                          onClick={() => setSelecteduser3(item)}
                                                          color="primary"
                                                          sx={{
                                                            fontSize: "16px",
                                                            borderRadius: "50%",
                                                            "&:hover": {
                                                              backgroundColor: "#a4adad",
                                                            },
                                                          }}
                                                        >
                                                          <GrValidate className=" dark:text-gray-100" />
                                                        </IconButton>
                                                      </Tooltip>
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                              {(item.physician_is_present === false || item.physician_is_present === 0) && (
                                                <tr key={`comment-${idx}`} className="border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800">
                                                  <td colSpan="8" className="p-2">
                                                    <div className="flex items-start">
                                                      <div className="mr-2 mt-1">
                                                        <svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                                                          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                                        </svg>
                                                      </div>
                                                      <div className="text-sm text-gray-700 dark:text-gray-300 break-words">
                                                        <strong>Doctorul nu a fost prezent</strong>
                                                      </div>
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                    </tbody>
                                  </table>

                                  <table className="w-full">
                                    <tbody>
                                      {Data2.filter((i) => i.visit_date === selectedInstitutionId.visit_date && i.user_id === selectedInstitutionId.user_id)
                                        .sort((a, b) => new Date(a.start_time) - new Date(b.start_time)).map((item, idx) => {
                                          return (
                                            <React.Fragment key={idx}>
                                              <tr>
                                                <td>
                                                  <div className="sm:hidden mb-4 p-3 rounded-lg bg-gray-100 dark:bg-gray-700">
                                                    <div className="grid grid-cols-1 gap-2">
                                                      <div className="flex items-center gap-2 p-2">
                                                        <div>
                                                          <div className="flex items-center">
                                                            <span className="text-gray-600 dark:text-gray-300 mr-2">Interval ora: </span>
                                                            {item.report_start_time && item.report_end_time && dayjs(item.report_start_time).isValid() && dayjs(item.report_end_time).isValid()
                                                              ? dayjs.utc(item.report_start_time).format('HH:mm') + ' - ' + dayjs.utc(item.report_end_time).format('HH:mm')
                                                              : '-'}
                                                          </div>

                                                          <h3 className="text-gray-900 dark:text-gray-100 flex items-center gap-1.5">
                                                            {item.obiect_type_id === 1 ? (
                                                              <>
                                                                <span>{item.physician?.name || item.physician || "-"}</span>
                                                                {(item.physician?.data_acord || item.data_acord) ? (
                                                                  <span title="Acord marketing confirmat" className="inline-flex items-center text-emerald-500 flex-shrink-0">
                                                                    <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor">
                                                                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                                    </svg>
                                                                  </span>
                                                                ) : null}
                                                              </>
                                                            ) : (
                                                              item.location?.institution
                                                            )}
                                                          </h3>

                                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                                            {item.location?.inst_type || "Nu exista institutie"}
                                                          </div>

                                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                                            {item.obiect_type_id === 1 ?
                                                              item.physician?.speciality + ' - ' + item.location?.institution
                                                              : null}
                                                          </div>

                                                          <div className="text-md text-gray-500 dark:text-gray-400">
                                                            {item.location?.address + " - " + item.location?.city || "-"}
                                                          </div>

                                                          <div className="flex items-center">
                                                            <span className="text-gray-600 dark:text-gray-300 mr-2">Tip: </span>
                                                            {item.planning_type_id === 1 ? "Planificat" : "Neplanificat"}
                                                          </div>

                                                          <div className="flex items-center">
                                                            <span className="text-gray-600 dark:text-gray-300 mr-2">Validat: </span>
                                                            <div className={`flex items-center justify-center font-semibold ${item.is_validated ? 'text-green-500' : 'text-red-500'}`}
                                                              style={{
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                                height: "100%",
                                                              }}>
                                                              {item.is_validated ? <LuCircleCheck size={20} /> : <LuCircleX size={20} />}
                                                            </div>
                                                          </div>

                                                          <div className="flex items-center">
                                                            <div
                                                              className="font-semibold text-right"
                                                              style={{
                                                                fontWeight: "bold",
                                                                fontSize: "20px",
                                                              }}
                                                            >

                                                              <Tooltip title="Editeaza" arrow placement="top">
                                                                <IconButton
                                                                  onClick={() => setSelecteduser(item)}
                                                                  data-tooltip-target="tooltip-default"
                                                                  color="primary"
                                                                  disabled={item.is_validated}
                                                                  sx={{
                                                                    fontSize: "16px",
                                                                    borderRadius: "50%",
                                                                    "&:hover": {
                                                                      backgroundColor: "#a4adad",
                                                                    },
                                                                    "&.Mui-disabled": {
                                                                      visibility: "hidden",
                                                                      color: "rgba(0, 0, 0, 0.09)",
                                                                      backgroundColor: "rgba(255, 255, 255, 0)",
                                                                    },
                                                                  }}
                                                                >
                                                                  <AiFillEdit className=" dark:text-gray-100" />
                                                                </IconButton>
                                                              </Tooltip>

                                                              <Tooltip title="Sterge" arrow placement="top">
                                                                <IconButton
                                                                  onClick={() => setSelecteddeleteuser(item)}
                                                                  color="primary"
                                                                  sx={{
                                                                    fontSize: "16px",
                                                                    borderRadius: "50%",
                                                                    "&:hover": {
                                                                      backgroundColor: "#a4adad",
                                                                    },
                                                                  }}
                                                                >
                                                                  <AiOutlineDelete className=" dark:text-gray-100" />
                                                                </IconButton>
                                                              </Tooltip>

                                                              <Tooltip title="Vizualizeaza" arrow placement="top">
                                                                <IconButton
                                                                  onClick={() => setSelecteduser2(item)}
                                                                  color="primary"
                                                                  sx={{
                                                                    fontSize: "16px",
                                                                    borderRadius: "50%",
                                                                    "&:hover": {
                                                                      backgroundColor: "#a4adad",
                                                                    },
                                                                  }}
                                                                >
                                                                  <FaEye className=" dark:text-gray-100" />
                                                                </IconButton>
                                                              </Tooltip>

                                                              {user && user.role !== 'User' && (
                                                                <Tooltip title="Validare" arrow placement="top">
                                                                  <IconButton
                                                                    onClick={() => setSelecteduser3(item)}
                                                                    color="primary"
                                                                    sx={{
                                                                      fontSize: "16px",
                                                                      borderRadius: "50%",
                                                                      "&:hover": {
                                                                        backgroundColor: "#a4adad",
                                                                      },
                                                                    }}
                                                                  >
                                                                    <GrValidate className=" dark:text-gray-100" />
                                                                  </IconButton>
                                                                </Tooltip>
                                                              )}

                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>

                                                    </div>
                                                    {(item.physician_is_present === false || item.physician_is_present === 0) && (
                                                      <tr key={`comment-${idx}`} className="border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800">
                                                        <td colSpan="8" className="p-2">
                                                          <div className="flex items-start">
                                                            <div className="mr-2 mt-1">
                                                              <svg className="w-4 h-4 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                                                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                                              </svg>
                                                            </div>
                                                            <div className="text-sm text-gray-700 dark:text-gray-300 break-words">
                                                              <strong>Doctorul nu a fost prezent</strong>
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            </React.Fragment>
                                          );
                                        })}
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="flex justify-center mt-4">
              <button
                onClick={() => handlePageChange(pagination.currentPage - 1)}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={pagination.currentPage === 1}
              >
                Prev
              </button>

              {pagination.currentPage > 3 && (
                <>
                  <button
                    onClick={() => handlePageChange(1)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    1
                  </button>
                  <span className="px-2">...</span>
                </>
              )}

              {Array.from({ length: Math.min(5, pagination.totalPages) }, (_, index) => {
                const startPage = Math.max(1, pagination.currentPage - 2);
                const page = startPage + index;

                if (page <= pagination.totalPages) {
                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      className={`px-4 py-2 text-sm font-medium ${pagination.currentPage === page
                        ? "bg-gray-500 text-white"
                        : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                        }`}
                    >
                      {page}
                    </button>
                  );
                }
                return null;
              })}

              {pagination.currentPage < pagination.totalPages - 2 && (
                <>
                  <span className="px-2">...</span>
                  <button
                    onClick={() => handlePageChange(pagination.totalPages)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    {pagination.totalPages}
                  </button>
                </>
              )}

              <button
                onClick={() => handlePageChange(pagination.currentPage + 1)}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={pagination.currentPage === pagination.totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DashboardCard25;